import { useState, useEffect, resolveIsDark } from "@";

export default function NotFound() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    if (darkMode) document.documentElement.classList.add("dark");
    else document.documentElement.classList.remove("dark");
  }, [darkMode]);

  useEffect(() => {
    setDarkMode(resolveIsDark());
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-white to-gray-50 px-4 py-10 dark:from-gray-950 dark:to-gray-900">
      <div className="w-full max-w-md">
        <div className="relative overflow-hidden rounded-2xl bg-white/85 shadow-xl shadow-purple-900/5 ring-1 ring-purple-100 backdrop-blur-md dark:bg-transparent dark:shadow-black/30 dark:ring-purple-700/40">
          {/* Top accent stripe — design-system pattern */}
          <span
            aria-hidden
            className="pointer-events-none absolute inset-x-0 top-0 h-0.5 bg-gradient-to-r from-transparent via-purple-500/60 to-transparent"
          />

          {/* Illustration band — quiet dotted-path that ends at a brand-tinted X */}
          <div className="flex h-36 items-center justify-center bg-gradient-to-b from-purple-50/30 to-transparent dark:from-purple-950/20">
            <svg
              viewBox="0 0 200 100"
              className="h-28 w-full text-purple-200 dark:text-purple-700/60"
              fill="none"
              aria-hidden
            >
              <path
                d="M10 80 C 50 30, 90 90, 130 50"
                stroke="currentColor"
                strokeWidth="2"
                strokeDasharray="3 5"
                strokeLinecap="round"
              />
              <circle
                cx="150"
                cy="40"
                r="14"
                fill="currentColor"
                opacity="0.25"
              />
              <path
                d="m144 34 12 12M156 34l-12 12"
                stroke="rgb(126 34 206)"
                strokeWidth="2.25"
                strokeLinecap="round"
                className="dark:stroke-purple-300"
              />
            </svg>
          </div>

          <div className="px-8 py-7 text-center">
            <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-purple-700 dark:text-purple-400">
              ٤٠٤ · NOT FOUND
            </p>
            <h1 className="mt-2 text-2xl font-black tracking-tight text-gray-900 dark:text-gray-100">
              لم نجد هذه الصفحة
            </h1>
            <p className="mx-auto mt-2 max-w-xs text-sm leading-relaxed text-gray-500 dark:text-gray-400">
              ربما تم نقل الصفحة أو حذفها، أو أن الرابط غير صحيح.
            </p>

            <div className="mt-6 flex flex-col items-center gap-3">
              <a href="/" className="btn-purple-900 !w-full justify-center">
                العودة للرئيسية
              </a>
              <button
                type="button"
                onClick={() => window.history.back()}
                className="text-sm font-medium text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200"
              >
                الرجوع للصفحة السابقة
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
